var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"col-md-3 service-link",attrs:{"id":_vm.service.id,"to":`${_vm.$router.options.routes[1].path}#${_vm.service.id}`,"tag":"div"}},[_c('i',{staticClass:"fa",class:_vm.service.icon,attrs:{"aria-hidden":"true"}}),_c('h2',[_vm._v(_vm._s(_vm.service.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }